export const phoneOrderMockData = [
  {
    id: 1,
    name: "John Doe",
    phoneNumber: "(456) 123-7892",
    email: "johnDoe@gmail.com",
    poNumber: "101",
    tradingPartnerName: "WAL MART D.C. 6056",
    shipDate: "2023-04-10T00:00:00",
    receiptDate: "2023-04-10T00:00:00",
    shipTo: "21",
    region: "tmx",
    lineItems: [
      {
        buyersItemId: "100",
        sellersItemId: "120",
        itemDescription: "SLD BWL CHF 7.25Z TF",
        quantity: "12"
      },
      {
        buyersItemId: "186",
        sellersItemId: "10",
        itemDescription: "MKS STHWST SALAD MAP",
        quantity: "56"
      }
    ]
  },
  {
    id: 2,
    name: "Rob Johnson",
    phoneNumber: "(234) 999-9120",
    email: "robJohnson@gmail.com",
    poNumber: "102",
    tradingPartnerName: "TARGET DISTRIBUTION 3098",
    shipDate: "2023-05-15T00:00:00",
    receiptDate: "2023-05-16T00:00:00",
    shipTo: "47",
    region: "tfl",
    lineItems: [
      {
        buyersItemId: "201",
        sellersItemId: "220",
        itemDescription: "ORGNC SPRING MX 16OZ BAG",
        quantity: "20"
      },
      {
        buyersItemId: "247",
        sellersItemId: "30",
        itemDescription: "GREEK YOGURT PARFAIT",
        quantity: "40"
      }
    ]
  },
  {
    id: 3,
    name: "Jane Smith",
    phoneNumber: "(818) 231-0189",
    email: "janeSmith@gmail.com",
    poNumber: "103",
    tradingPartnerName: "COSTCO WHOLESALE 704",
    shipDate: "2023-06-01T00:00:00",
    receiptDate: "2023-06-02T00:00:00",
    shipTo: "88",
    region: "tmd",
    lineItems: [
      {
        buyersItemId: "300",
        sellersItemId: "320",
        itemDescription: "VEGAN CHOCOLATE CAKE",
        quantity: "15"
      },
      {
        buyersItemId: "375",
        sellersItemId: "40",
        itemDescription: "QUINOA SALAD BOX",
        quantity: "25"
      }
    ]
  }
];
